export const range = (count = 0) => Array.from(Array(count).keys());
